/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceAdminDocumentResource } from './';
import {
    ComplianceAdminDocumentResourceFromJSON,
    ComplianceAdminDocumentResourceFromJSONTyped,
    ComplianceAdminDocumentResourceToJSON,
} from './';
import type { DocumentTypeResource } from './';
import {
    DocumentTypeResourceFromJSON,
    DocumentTypeResourceFromJSONTyped,
    DocumentTypeResourceToJSON,
} from './';
import type { ProviderFileData } from './';
import {
    ProviderFileDataFromJSON,
    ProviderFileDataFromJSONTyped,
    ProviderFileDataToJSON,
} from './';

/**
 * 
 * @export
 * @interface ComplianceAdminDocumentsByTypeResource
 */
export interface ComplianceAdminDocumentsByTypeResource {
    /**
     * 
     * @type {string}
     * @memberof ComplianceAdminDocumentsByTypeResource
     */
    documentTypeId: string;
    /**
     * 
     * @type {DocumentTypeResource}
     * @memberof ComplianceAdminDocumentsByTypeResource
     */
    documentType: DocumentTypeResource;
    /**
     * 
     * @type {string}
     * @memberof ComplianceAdminDocumentsByTypeResource
     */
    documentLabel: string;
    /**
     * 
     * @type {ComplianceAdminDocumentResource}
     * @memberof ComplianceAdminDocumentsByTypeResource
     */
    latestUploadedDoc: ComplianceAdminDocumentResource;
    /**
     * 
     * @type {{ [key: string]: ProviderFileData; }}
     * @memberof ComplianceAdminDocumentsByTypeResource
     */
    providerData: { [key: string]: ProviderFileData; };
}

/**
 * Check if a given object implements the ComplianceAdminDocumentsByTypeResource interface.
 */
export function instanceOfComplianceAdminDocumentsByTypeResource(value: object): value is ComplianceAdminDocumentsByTypeResource {
    if (!('documentTypeId' in value) || value['documentTypeId'] === undefined) return false;
    if (!('documentType' in value) || value['documentType'] === undefined) return false;
    if (!('documentLabel' in value) || value['documentLabel'] === undefined) return false;
    if (!('latestUploadedDoc' in value) || value['latestUploadedDoc'] === undefined) return false;
    if (!('providerData' in value) || value['providerData'] === undefined) return false;
    return true;
}

export function ComplianceAdminDocumentsByTypeResourceFromJSON(json: any): ComplianceAdminDocumentsByTypeResource {
    return ComplianceAdminDocumentsByTypeResourceFromJSONTyped(json, false);
}

export function ComplianceAdminDocumentsByTypeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceAdminDocumentsByTypeResource {
    if (json == null) {
        return json;
    }
    return {
        
        'documentTypeId': json['documentTypeId'],
        'documentType': DocumentTypeResourceFromJSON(json['documentType']),
        'documentLabel': json['documentLabel'],
        'latestUploadedDoc': ComplianceAdminDocumentResourceFromJSON(json['latestUploadedDoc']),
        'providerData': (mapValues(json['providerData'], ProviderFileDataFromJSON)),
    };
}

export function ComplianceAdminDocumentsByTypeResourceToJSON(value?: ComplianceAdminDocumentsByTypeResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'documentTypeId': value['documentTypeId'],
        'documentType': DocumentTypeResourceToJSON(value['documentType']),
        'documentLabel': value['documentLabel'],
        'latestUploadedDoc': ComplianceAdminDocumentResourceToJSON(value['latestUploadedDoc']),
        'providerData': (mapValues(value['providerData'], ProviderFileDataToJSON)),
    };
}

